import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { DEALER_EVENTS } from 'client/site-modules/dealerships/utils/dealer-events';

function engagementHandler() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      subaction_name: 'ddp_view_dealer_reviews',
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      value: 'read sales reviews',
    },
  });
}

export const DealerInternalReferrerEngagementHandler = {
  init() {
    EventToolbox.on(DEALER_EVENTS.INTERNAL_REFERRER, engagementHandler);
  },
};
